import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  doAddPartner,
  doFetchPartner,
  doViewPartner,
  doEditPartner,
  doDeactivatePartner,
  doApprovePartner,
  doRejectPartner,
  doActivatePartner,
  doGetActivePartners,
  doGetLoggedInPartnerDetails,
  doUploadPartnerPhoto,
  doGetPartnerAgents,
} from "../../service/partner";

import errorMessage from "../../utils/error.json";

// fetch partner list
function* fetchPartnerTask(action) {
  try {
    yield put({ type: OP.PARTNER_LIST_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doFetchPartner, payload.token);

    if (res.status == 200) {
      yield put({
        type: OP.PARTNER_LIST_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.PARTNER_LIST_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.PARTNER_LIST_FAILURE,
      payload: errMsg,
    });
  }
}

// add partner
function* addPartnerTask(action) {
  try {
    yield put({ type: OP.ADD_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doAddPartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ADD_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ADD_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ADD_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// view partner
function* viewPartnerTask(action) {
  try {
    yield put({ type: OP.VIEW_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewPartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// edit partner
function* editPartnerTask(action) {
  try {
    yield put({ type: OP.EDIT_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doEditPartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.EDIT_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.EDIT_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.EDIT_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// deactiavate partner
function* activatePartnerTask(action) {
  try {
    yield put({ type: OP.ACTIVATE_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doActivatePartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ACTIVATE_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ACTIVATE_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ACTIVATE_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// deactiavate partner
function* deactivatePartnerTask(action) {
  try {
    yield put({ type: OP.DEACTIVATE_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDeactivatePartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DEACTIVATE_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DEACTIVATE_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DEACTIVATE_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// approve Partner
function* approvePartnerTask(action) {
  try {
    yield put({ type: OP.APPROVE_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doApprovePartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.APPROVE_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.APPROVE_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.APPROVE_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// reject Partner
function* rejectPartnerTask(action) {
  try {
    yield put({ type: OP.REJECT_PARTNER_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doRejectPartner,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.REJECT_PARTNER_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.REJECT_PARTNER_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.REJECT_PARTNER_FAILURE,
      payload: errMsg,
    });
  }
}

// get active partners
function* getActivePartnersTask(action) {
  try {
    yield put({ type: OP.GET_ACTIVE_PARTNERS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetActivePartners,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.GET_ACTIVE_PARTNERS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.GET_ACTIVE_PARTNERS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.GET_ACTIVE_PARTNERS_FAILURE,
      payload: errMsg,
    });
  }
}

// get logged In Partner Details
function* getLoggedInPartnerDetailsTask(action) {
  try {
    yield put({ type: OP.GET_LOGGED_IN_PARTNER_DETAILS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetLoggedInPartnerDetails,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.GET_LOGGED_IN_PARTNER_DETAILS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.GET_LOGGED_IN_PARTNER_DETAILS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.GET_LOGGED_IN_PARTNER_DETAILS_FAILURE,
      payload: errMsg,
    });
  }
}

// upload partner photo
function* uploadPartnerPhotoTask(action) {
  try {
    yield put({ type: OP.UPLOAD_PARTNER_PHOTO_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUploadPartnerPhoto,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.UPLOAD_PARTNER_PHOTO_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPLOAD_PARTNER_PHOTO_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.UPLOAD_PARTNER_PHOTO_FAILURE,
      payload: errMsg,
    });
  }
}

// get partner agents
function* getPartnerAgentsTask(action) {
  try {
    yield put({ type: OP.GET_PARTNER_AGENTS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetPartnerAgents,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.GET_PARTNER_AGENTS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.GET_PARTNER_AGENTS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.GET_PARTNER_AGENTS_FAILURE,
      payload: errMsg,
    });
  }
}

function* partnerSaga() {
  yield takeLatest(OP.PARTNER_LIST_REQUEST, fetchPartnerTask);
  yield takeLatest(OP.ADD_PARTNER_REQUEST, addPartnerTask);
  yield takeLatest(OP.VIEW_PARTNER_REQUEST, viewPartnerTask);
  yield takeLatest(OP.EDIT_PARTNER_REQUEST, editPartnerTask);
  yield takeLatest(OP.ACTIVATE_PARTNER_REQUEST, activatePartnerTask);
  yield takeLatest(OP.DEACTIVATE_PARTNER_REQUEST, deactivatePartnerTask);
  yield takeLatest(OP.APPROVE_PARTNER_REQUEST, approvePartnerTask);
  yield takeLatest(OP.REJECT_PARTNER_REQUEST, rejectPartnerTask);
  yield takeLatest(OP.GET_ACTIVE_PARTNERS_REQUEST, getActivePartnersTask);
  yield takeLatest(
    OP.GET_LOGGED_IN_PARTNER_DETAILS_REQUEST,
    getLoggedInPartnerDetailsTask,
  );
  yield takeLatest(OP.UPLOAD_PARTNER_PHOTO_REQUEST, uploadPartnerPhotoTask);
  yield takeLatest(OP.GET_PARTNER_AGENTS_REQUEST, getPartnerAgentsTask);
}

export default partnerSaga;
